import React from "react";
import { RuleCard } from "./RuleCard";
import { STAGE_HINT } from "./ruleText";

export function RuleList({ rules, schema, hubName, handlers, selection }) {
  return (
    <div className="space-y-8" data-testid="rule-list">
      {schema.stages.map((s, i) => {
        const mine = rules.filter((r) => r.stage === s.id);
        return (
          <section key={s.id} data-testid={`rule-stage-${s.id}`}>
            <div className="flex items-baseline gap-3 mb-3">
              <span className="font-mono text-xs text-[#73bf44]">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-heading text-base font-semibold text-white">{s.label}</h3>
              <span className="text-xs text-neutral-600">{mine.length} rule{mine.length === 1 ? "" : "s"}</span>
            </div>
            <p className="text-xs text-neutral-500 -mt-2 mb-3">{STAGE_HINT[s.id]}</p>
            <div className="space-y-2">
              {mine.length === 0 && <div className="text-sm text-neutral-600 border border-dashed border-neutral-800 rounded-xl px-4 py-5">No rules here yet.</div>}
              {mine.map((r) => (
                <RuleCard key={r.id} rule={r} schema={schema} hubName={hubName} {...handlers}
                  selecting={selection?.selecting} checked={selection?.selected.has(r.id)} onCheck={selection?.onCheck} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
